<div class="statistics__card flex flex-col gap-6">
  <div class="card__header flex justify-between">
    <div class="header__details flex flex-col gap-4">
      <p class="visitors__total" [translate]="cardTitle"></p>
      <p class="visitors__count" [innerText]="total"></p>
    </div>

    <div
      class="header__icon"
      [inlineSVG]="icon"
    >
  </div>
  </div>

  <div class="card__footer flex items-center gap-3">
    <div class="increase flex items-center gap-2">
      <div inlineSVG="features/increase.svg"></div>
      <span>8.5 %</span>
    </div>
    <p translate="Up from yesterday"></p>
  </div>
</div>



